import React from "react";
import SubjectTopics from "../subjectTopics"; // Import the SubjectTopics component

// Algebra Component
// This component renders a SubjectTopics component for the Algebra subject
const Algebra = () => <SubjectTopics subjectId={2} title="Algebra" />;

export default Algebra; // Export the Algebra component
